import { AxiosInstance } from 'axios';
import * as FileSaver from 'file-saver';

import { insertId } from '../insertId';
import { cancellable } from '../cancellable';

export default (api: AxiosInstance, url: string) => (
  marketId: number,
  templateId: number
) => {
  const urlWithId = insertId(insertId(url, marketId), templateId);

  return cancellable<any>(
    (cancelOptions: any) =>
      api.get(urlWithId, {
        ...cancelOptions,
        responseType: 'blob',
      }),
    (data: any, headers: any) => {
      const header = headers['content-disposition'];
      const filename = header.split('filename=')[1];
      FileSaver.saveAs(data, filename);
    }
  );
};



// WEBPACK FOOTER //
// ./src/services/api/linkUpload/downloadTemplate.ts